/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Phrism SMCR API
 * OpenAPI spec version: v1
 */

export type PlatformRole = typeof PlatformRole[keyof typeof PlatformRole];


export const PlatformRole = {
  Compliance: 'Compliance',
  HR: 'HR',
  LineManager: 'LineManager',
  Employee: 'Employee',
  CompanyAdmin: 'CompanyAdmin',
} as const;
